// V4 accounts have no reference, language or timezone field; they live in settings.
export const V4_ACCOUNT_REFERENCE_SETTING = 'reference';
export const V4_ACCOUNT_LANGUAGE_SETTING = 'language';
export const V4_ACCOUNT_TIMEZONE_SETTING = 'timezone';

// Undefined when unset, so the Account defaults apply.
export const storedV4AccountReference = settings => settings?.[V4_ACCOUNT_REFERENCE_SETTING] || undefined;
export const storedV4AccountLanguage = settings => settings?.[V4_ACCOUNT_LANGUAGE_SETTING] || undefined;
// '' when unset: the Account default would pass for a stored timezone.
export const storedV4AccountTimezone = settings => settings?.[V4_ACCOUNT_TIMEZONE_SETTING] || '';

// null keeps the stored value; an emptied reference is removed.
export function withV4AccountProfile(settings, {reference = null, language = null, timezone = null} = {}) {
  const next = {...(settings || {})};
  if (reference !== null) {
    if (reference) next[V4_ACCOUNT_REFERENCE_SETTING] = reference;
    else delete next[V4_ACCOUNT_REFERENCE_SETTING];
  }
  if (language) next[V4_ACCOUNT_LANGUAGE_SETTING] = language;
  if (timezone) next[V4_ACCOUNT_TIMEZONE_SETTING] = timezone;
  return next;
}
